import PropTypes from 'prop-types';
import { ENGAGEMENTS } from './EngagementTypes';
import { INTERACTIONS } from '../interaction/InteractionTypes';

/**
 * @deprecated Use EngagementOrInteraction
 */
export const EngagementOrInteractionTypePropType = PropTypes.oneOf([...ENGAGEMENTS, ...INTERACTIONS]);